import { useEffect, useState } from "react";
import Button from "../ui/Button";
import logIcon from "../../assets/images/log-icon.png";
import Text from "../../../../components/ui/Text";
import { truncString } from "../../helpers";

interface Props {
  className?: string;
  onLogClick?: (log: LogType) => void;
}

type LogType = {
  id: string;
  date: string;
  time: string;
  message: string;
  title: string;
};

const Logs = ({ className = "", onLogClick = () => {} }: Props) => {
  const [logs /*setLogs*/] = useState<LogType[]>([
    {
      id: "1",
      title: "R. Richardson",
      message: "What he did here in few words as example",
      date: "08.08.2025",
      time: "18:40",
    },
    {
      id: "2",
      title: "R. Richardson",
      message:
        "What he did here in few words as example test test test test test",
      date: "08.08.2025",
      time: "18:40",
    },
    {
      id: "3",
      title: "R. Richardson",
      message: "What he did here in few words as example",
      date: "08.08.2025",
      time: "18:40",
    },
    {
      id: "4",
      title: "R. Richardson",
      message: "What he did here in few words as example",
      date: "08.08.2025",
      time: "18:40",
    },
    {
      id: "5",
      title: "R. Richardson",
      message: "What he did here in few words as example",
      date: "08.08.2025",
      time: "18:40",
    },
    {
      id: "6",
      title: "R. Richardson",
      message: "What he did here in few words as example",
      date: "08.08.2025",
      time: "18:40",
    },
  ]);

  useEffect(() => {
    // fetchLogs().then(setLogs)
  }, []);

  return (
    <div className={`${className}`}>
      <div className="space-y-2 my-3 overflow-y-scroll scrollbar-hide max-h-[250px]">
        {logs?.map((log) => (
          <Button
            key={log.id}
            className="rounded-md"
            variant="light-gray"
            onClick={() => {
              onLogClick(log);
            }}
          >
            <div className="flex items-start space-x-2 text-left">
              <img
                src={logIcon}
                alt="Log"
                className="w-[29px] h-[29px] rounded-sm"
              />

              <div>
                <Text size="xxs" className="text-[#56F5FF]">
                  {log.title}{" "}
                  <span className="text-white  text-[11px]">{`[${log.message.length}]`}</span>
                </Text>
                <Text size="xxxs" className="text-white/70 leading-3 mb-2 mt-1">
                  {truncString(log.message, 43)}
                </Text>

                <Text size="xxxs" className="text-white/30 leading-3">
                  {log.date} / {log.time}
                </Text>
              </div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Logs;
